import { Button, Form, message, Input, Col, Row, Select, DatePicker, Modal } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import orderPaymentApis from 'api/orderPaymentApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';
import { orderTypes, orderStatus, FromPlans, VatRequests, VatExports } from './helpers';
import { defaultDateFormat } from 'helpers/dateTimeHelper';
import { exportOrdersToCSV } from './helpers';
import moment from 'moment';

export default function ListOrderPaymentsPartnerPage() {

  const [orderPayments, setOrderPayments] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({});
  const [totalAmounts, setTotalAmounts] = useState({
    original: 0,
    actual: 0
  })
  const [searchForm] = Form.useForm();
  // Set default dates with moment.js
  const now = moment();
  const startDateDefault = now.clone().subtract(30, 'days').startOf('day'); // 30 days ago, start of the day
  const endDateDefault = now.clone().endOf('day'); // Current time, end of the day


  async function fetchOrderPayments(params={}) {
    setIsFetching(true);
    try {
      const res = await orderPaymentApis.listing_partner(params);
      if (res.code === 200) {
        // Check if this is an export request
        if (params.is_export === 'true') {
          // Call the export function with the data
          exportOrdersToCSV(res);
          searchForm.setFieldsValue({ 
            is_export: undefined
          });
        } else {
          // Normal data display flow
          setOrderPayments(res.data || []);
          setPaginate({
            page: res.page || 1, 
            limit: res.limit || 10, 
            total: res.total || 0
          });
          setTotalAmounts({
            original: res.total_amount_original || 0,
            actual: res.total_amount || 0
          });
        }
      }
    } catch (error) {
      message.info(error.message || 'An error occurred');
      // Set default values to prevent undefined errors
      setOrderPayments([]);
      setPaginate({page: 1, limit: 10, total: 0});
    }
    setIsFetching(false);
  }


  const defaultValues = {
    start_date: startDateDefault, // Assuming this is a `moment` object
    end_date: endDateDefault,    // Assuming this is a `moment` object
  };

  function fetchDataByDefaultForm() {
    const formattedValues = {
      ...defaultValues,
      start_date: defaultValues.start_date ? defaultValues.start_date.format('DD/MM/YYYY') : null,
      end_date: defaultValues.end_date ? defaultValues.end_date.format('DD/MM/YYYY') : null,
    };
    onFinishSearchForm(formattedValues);
  }

  useEffect(() => {
    fetchDataByDefaultForm()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const formValues = searchForm.getFieldsValue();
    const formattedValues = {
      ...formValues,
      start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
      end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
    };
    const args = Object.assign({}, params, formattedValues)
    await fetchOrderPayments(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchOrderPayments(params)
  };


  const bottom = 'bottomRight';

  const [selectedOrderId, setSelectedOrderId] = useState(null);


  const columns = [
    {
      title: 'ID',
      width: '20rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'tenant_id',
      width: '20rem',
      render: (record) => <span>{record.tenant_id}</span>
    },
    {
      title: 'plan_id',
      width: '20rem',
      render: (record) => <span>{record.plan_id}({record.plan_name})</span>
    },
    {
      title: 'prefilled_email',
      width: '20rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.prefilled_email}</span>
    },
    {
      title: 'status',
      width: '20rem',
      render: (record) => <span>{record.status}</span>
    },
    {
      title: 'code',
      width: '20rem',
      render: (record) => <span>{record.code}</span>
    },
    {
      title: 'discount_code',
      width: '25rem',
      render: (record) => (
        <span>
          {record.discount_code ? 
            `${record.discount_code.code} (${new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(record.discount_code.discount_value)})` : 
            'N/A'}
        </span>
      )
    },
    {
      title: 'amount',
      width: '20rem',
      render: (record) => <span>{record.amount}</span>
    },
    {
      title: 'quantity',
      width: '20rem',
      render: (record) => <span>{record.quantity}</span>
    },
    {
      title: 'webhooks',
      width: '30rem',
      render: (record) => <span>{record.webhooks}</span>
    },
    {
      title: 'from_domain',
      width: '30rem',
      render: (record) => <span>{record.from_domain}</span>
    },
    {
      title: 'Created At',
      width: '20rem',
      key: 'created_at',
      sorter: true,
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả OrderPayments của Partner"
        pageHeaderExtras={
          <>
            <Button
              style={{
                margin: '0 8px',
              }}
              type="primary"
              onClick={() => {
                // Set a specific value in the form
                searchForm.setFieldsValue({ 
                  is_export: 'true'
                });
                
                // Get all current form values
                const formValues = searchForm.getFieldsValue();
                
                // Format dates properly
                const formattedValues = {
                  ...formValues,
                  start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
                  end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
                };
                
                // Call the API directly with the export parameter
                fetchOrderPayments(formattedValues);
              }}
            >
              Export Orders
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
        <div style={{ marginBottom: "24px" }}>
          <Row gutter={24}>
            <Col span={12}>
              <div style={{ background: "#f0f2f5", padding: "20px", borderRadius: "8px" }}>
                <h3 style={{ marginBottom: "8px", color: "#1890ff" }}>Tổng số tiền thực tế theo gói</h3>
                <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                  {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(totalAmounts.original)}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ background: "#f0f2f5", padding: "20px", borderRadius: "8px" }}>
                <h3 style={{ marginBottom: "8px", color: "#1890ff" }}>Tổng số tiền đã chuyển khoản</h3>
                <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                  {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(totalAmounts.actual)}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          style={{marginBottom: "40px"}}
          initialValues={{
            start_date: startDateDefault,
            end_date: endDateDefault,
          }}
          onFinish={(values) => {
            // Format the start_date and end_date before submitting
            const formattedValues = {
              ...values,
              start_date: values.start_date ? values.start_date.format('DD/MM/YYYY') : null,
              end_date: values.end_date ? values.end_date.format('DD/MM/YYYY') : null,
            };
            console.log(formattedValues)
            // Call the server submission logic with the formatted values
            onFinishSearchForm(formattedValues);
          }}
        >
          {/* Add hidden form field for is_export */}
          <Form.Item name="is_export" hidden>
            <Input />
          </Form.Item>
          
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="start_date"
                label="Start Date"
                labelCol={{ span: 8 }}
              >
                <DatePicker 
                  placeholder="Select Start Date" 
                  style={{ width: '100%' }}
                  format={defaultDateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="end_date"
                label="End Date"
                labelCol={{ span: 8 }}
              >
                <DatePicker 
                  placeholder="Select End Date" 
                  style={{ width: '100%' }} 
                  format={defaultDateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='order_payment_id'
                label='order_payment_id'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm order payment id" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='tenant_id'
                label='tenant_id'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm theo tenant_id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='code'
                label='code'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm theo code" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='prefilled_email'
                label='prefilled_email'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="prefilled_email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item 
                label="Status"
                name="status"
                labelCol={{ span: 8 }}
              >
                <Select options={orderStatus} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="Domain"
                name="domain"
                required={true}
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm theo domain" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="plan"
                name="plan_id"
                labelCol={{ span: 8 }}
              >
                <Select placeholder="Select a plan">
                  <Select.Option value="P21001">STARTER 1 tháng</Select.Option>
                  <Select.Option value="P21002">STARTER 3 tháng</Select.Option>
                  <Select.Option value="P21004">STARTER 6 tháng</Select.Option>
                  <Select.Option value="P21003">STARTER 1 năm</Select.Option>
                  <Select.Option value="P22001">GROW 1 tháng</Select.Option>
                  <Select.Option value="P22002">GROW 3 tháng</Select.Option>
                  <Select.Option value="P22004">GROW 6 tháng</Select.Option>
                  <Select.Option value="P22003">GROW 1 năm</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            
          </Row>
         
          <Row>
            <Col
              span={24}
              style={{
                textAlign: 'right',
              }}
            >
            
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  fetchDataByDefaultForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={orderPayments}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}
